import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { AuthService } from '../../../services';

@Component({
    selector: 'sn-usc-p2w-nav',
    templateUrl: './usc-p2w-nav.component.html',
    styleUrls: ['./usc-p2w-nav.component.css']
})
export class UscP2wNavComponent implements OnInit {
    @Input() view: string;

    campaigns: Array<any> = [
        { text: 'All', value: 'ALL' },
        { text: 'Account Growth', value: 'Account Growth' },
        { text: 'Add-A-Line', value: 'Add-A-Line' },
        { text: 'Referral', value: 'Referral' }
    ];

    store_unassigned_leads: number = 0;
    show_search_impression: boolean = false;
    current_campaign: string = "All";
    currentViewClass: any = {
        view_usc_p2w_todays_goal: "nav-item",
        view_usc_p2w_this_action_plan: "nav-item",
        view_usc_p2w_next_action_plan: "nav-item",
        view_usc_p2w_payout_estimator: "nav-item",
        view_usc_p2w_day_tracker: "nav-item",
        view_usc_p2w_dashboards: "nav-item",
        view_usc_p2w_scorecard: "nav-item",
        view_usc_book_of_business: "nav-item",
        view_usc_p2w_detail_results: "nav-item",
        view_usc_p2w_sales_tracker: "nav-item",
        view_usc_p2w_plan_2_win: "nav-item",
        view_usc_p2w_team_this_action_plans: "nav-item",
        view_usc_p2w_team_next_action_plans: "nav-item",
        view_usc_p2w_competitions: "nav-item",
        view_usc_p2w_challenges: "nav-item",
        view_usc_p2w_my_competitions: "nav-item",
        view_usc_p2w_my_challenges: "nav-item",
        view_usc_p2w_my_points: "nav-item",
        view_usc_p2w_my_badges: "nav-item",
        view_usc_p2w_associate_detailed_results: "nav-item",
        view_usc_p2w_associate_todays_detailed_results: "nav-item",
        view_usc_p2w_previous_action_plans: "nav-item",
        view_usc_retail_foundations: "nav-item",
        view_usc_p2w_sales_scorecard: "nav-item",
        view_usc_uploaded_documents: "nav-item",
    }

    isAdmin: boolean = false;
    isLeader: boolean = false;
    isReportAllowed: boolean = false;
    isTelesales: boolean = false;
    isUSCellCorp: boolean = false;
    isGamification: boolean = true;
    isPreviousMonthEnabled: boolean = true;
    show_retail_foundations: boolean = false;
    isStoreMgrOrAssistant: boolean = false;
    isTelesaleManagers: boolean = false;
    enable_sales_scorecard: boolean = true;

    constructor(
        public uscStoreService: UscStoreService,
        private authService: AuthService,
        private router: Router,
    ) { }

    ngOnInit() {
        this.isPreviousMonthEnabled = !this.uscStoreService.isUSCellAgent();
        this.enable_sales_scorecard = !this.uscStoreService.isUSCellTelesales();

        for (var p in this.currentViewClass) {
            this.currentViewClass[p] = "nav-item";
            if (p == this.view) {
                this.currentViewClass[p] = "nav-item active";
            }
        }

        this.authService.currentUser.subscribe(
            user => {
                this.isAdmin = this.uscStoreService.isAdmin();
                this.isLeader = this.uscStoreService.isLeader();
                this.isReportAllowed = this.uscStoreService.isReportAllowed();
                this.isTelesales = this.uscStoreService.isUSCellTelesales();
                this.isUSCellCorp = this.uscStoreService.isUSCellCorp();
                this.isStoreMgrOrAssistant = this.uscStoreService.isStoreMgrOrAssistant();
                this.isTelesaleManagers = this.uscStoreService.isTelesalesManager();
            }
        )

        // HACK: make leader nav item active
        if (this.view == this.uscStoreService.view_p2w_this_action_plan) this.currentViewClass.view_usc_p2w_team_this_action_plans = "nav-item active";
        if (this.view == this.uscStoreService.view_p2w_next_action_plan) this.currentViewClass.view_usc_p2w_team_next_action_plans = "nav-item active";
        if (this.view == this.uscStoreService.view_p2w_prev_action_plan) this.currentViewClass.view_usc_p2w_previous_action_plans = "nav-item active";
        if (this.view == this.uscStoreService.view_p2w_associate_gross_adds_detail_results) this.currentViewClass.view_usc_p2w_sales_scorecard = "nav-item active";
        if (this.view == this.uscStoreService.view_p2w_associate_accessory_detail_results) this.currentViewClass.view_usc_p2w_sales_scorecard = "nav-item active";
        if (this.isDetailResults()) this.currentViewClass.view_usc_p2w_detail_results = "nav-item active";
        this.show_retail_foundations = (this.view == this.uscStoreService.view_retail_foundations);
    }

    isPayoutEstimatorEnabled() {
        return ((!this.isAdmin && !this.isLeader) || this.isStoreMgrOrAssistant || this.isTelesaleManagers) && !this.uscStoreService.isUSCellAgent();
    }

    navigate(selection) {
        this.uscStoreService.setCurrentView(selection);
    }

    isDetailResults() {
        switch (this.view) {
            case this.uscStoreService.view_p2w_goal_gross_adds_detail_results:
            case this.uscStoreService.view_p2w_goal_accessory_detail_results:
            case this.uscStoreService.view_p2w_quota_gross_adds_detail_results:
            case this.uscStoreService.view_p2w_quota_accessory_detail_results:
                return true;
        }
        return false;
    }

    isAssociateThisMonthsDetailedResults() { return this.view == this.uscStoreService.view_p2w_associate_detailed_results; }
    isAssociateTodaysDetailedResults() { return this.view == this.uscStoreService.view_p2w_associate_todays_detailed_results; }

    reloadP2WAchievements() {
        this.uscStoreService.setActionPlan(null);
        this.uscStoreService.setTodaysGoal(null);
        this.uscStoreService.triggerReloadP2WAchievements();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-p2w-nav/usc-p2w-nav.component.ts